import React, { Component, useContext, useEffect, useState } from "react";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Link from "@mui/material/Link";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Typography from "@mui/material/Typography";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import "../assets/css/login.css";
import AuthContext from "../helpers/AuthContext";
import { Alert, Stack } from "@mui/material";
import { useNavigate } from "react-router-dom";
function Copyright(props) {
  return (
    <Typography
      variant="body2"
      color="text.secondary"
      align="center"
      {...props}>
      {"Copyright © "}
      <Link color="inherit" href="#">
        Acumen Automation
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

// TODO remove, this demo shouldn't need to reset the theme.

const defaultTheme = createTheme();

export default function Login({ history }) {
  const [error, setError] = useState("");
  const [loginForm, setLoginForm] = useState({
    email: "",
    password: "",
  });

  const handleChange = (event) => {
    setLoginForm((prevState) => ({
      ...prevState,
      [event.target.name]: event.target.value,
    }));
  };
  const { loginUser } = useContext(AuthContext);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!loginForm.email) {
      setError("Please enter valid email address.");
      return;
    }
    if (!loginForm.password) {
      setError("Password can not be empty");
      return;
    }

    await loginUser(loginForm.email, loginForm.password)
      .then((res) => {
        res ? navigate("/") : setError("Invalid login credentials");
      })
      .catch((err) => {
        setError(
          err?.response?.data?.message
            ? err.response.data.message
            : "Invalid login credentials"
        );
      });
  };
  return (
    <section
      className="h-100 gradient-form w-100"
      style={{ backgroundColor: "rgb(23,61,102,.2)" }}>
      <div className="container py-5 h-100">
        <div className="row d-flex justify-content-center align-items-center h-100">
          <div className="col-xl-10">
            <div className="card rounded-3 text-black">
              <div className="row g-0">
                <div className="col-lg-6">
                  <div className="card-body p-md-5 mx-md-4">
                    <div className="text-center">
                      {/* <img
                        src="https://mdbcdn.b-cdn.net/img/Photos/new-templates/bootstrap-login-form/lotus.webp"
                        style={{ width: 185 }}
                        alt="logo"
                      /> */}
                      <h4 className="mt-3 mb-4 pb-5"> M E A T W O R X</h4>
                    </div>
                    <form onSubmit={handleSubmit}>
                      <p className="mb-3 text-center">
                        Please login to your account
                      </p>

                      <div className=" mb-3">
                        {/* <input
                          type="email"
                          id="form2Example11"
                          className="form-control"
                          placeholder="Email address"
                        />
                        <label className="form-label" htmlFor="form2Example11">
                          Email
                        </label> */}
                        <TextField
                          type="text"
                          name="email"
                          value={loginForm.email}
                          onChange={handleChange}
                          placeholder="Email"
                          variant="outlined"
                          fullWidth
                          margin="normal"
                        />
                      </div>
                      <div className=" mb-3">
                        <TextField
                          type="password"
                          name="password"
                          value={loginForm.password}
                          onChange={handleChange}
                          placeholder="Password"
                          variant="outlined"
                          fullWidth
                          margin="normal"
                        />
                        {/* <input
                          type="password"
                          id="form2Example22"
                          className="form-control"
                        />
                        <label className="form-label" htmlFor="form2Example22">
                          Password
                        </label> */}
                      </div>
                      <div className="text-center d-flex flex-column pt-1 mb-5 pb-5">
                        <button
                          className="btn btn-primary fa-lg gradient-custom-2 mb-4 py-4"
                          type="submit">
                          Log in
                        </button>
                        {error && (
                          <Stack
                            sx={{
                              width: "100%",
                            }}
                            className="p-0 m-0">
                            <Alert severity="error">{error}</Alert>
                          </Stack>
                        )}
                        {/* <a className="text-muted" href="#!">
                          Forgot password?
                        </a> */}
                      </div>
                      {/* <div className="d-flex align-items-center justify-content-center pb-4">
                        <p className="mb-0 me-2">Don't have an account?</p>
                        <button
                          type="button"
                          data-mdb-button-init
                          data-mdb-ripple-init
                          className="btn btn-outline-danger">
                          Create new
                        </button>
                      </div> */}
                    </form>
                  </div>
                </div>
                <div className="col-lg-6 d-flex align-items-center gradient-custom-2">
                  <div className="text-white px-3 py-4 p-md-5 mx-md-4 text-center">
                    <h4 className="mb-0">
                        Food value chain management software
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
